// extracted by mini-css-extract-plugin
var _1 = "LabPageWrapper__engine--ws3o9";
var _2 = "LabPageWrapper__labBackground--tSAnR";
var _3 = "LabPageWrapper__level--tOkuj";
var _4 = "LabPageWrapper__top--qa3g0 CoreGeneral__pageTop--fP1Xg CoreGeneral__pageTopBase--WVn7b";
export { _1 as "engine", _2 as "labBackground", _3 as "level", _4 as "top" }
